import { render } from "./ContactPersonContainerView.vue?vue&type=template&id=9a322ac8&ts=true"
import script from "./ContactPersonContainerView.vue?vue&type=script&lang=ts"
export * from "./ContactPersonContainerView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__